import React from 'react';
import {
  Radio,
  RadioGroup,
  Text,
  VerticalSpace,
} from '@brokerbay/design-components';
import { FeedbackInputProps } from '../types';

type FeedbackRadioProps = FeedbackInputProps;

const FeedbackRadio: React.FC<FeedbackRadioProps> = ({
  disabled,
  onChange,
  template: { options, response },
}) => {
  const _onChange = (ev: any) => {
    onChange(ev);
  };
  return (
    <RadioGroup disabled={disabled} value={response} onChange={_onChange}>
      <VerticalSpace size="small">
        {options.map(option => (
          <Radio key={option} value={option}>
            {option}
          </Radio>
        ))}
      </VerticalSpace>
    </RadioGroup>
  );
};

export default FeedbackRadio;
